/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_24_HoursInputs */

const en_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 Hours`)
};

const fr_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 heures`)
};

const de_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 Stunden`)
};

const it_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 ore`)
};

const ru_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 часа`)
};

const es_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 horas`)
};

const zh_cn2_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24小时`)
};

const ja_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24時間`)
};

const hi_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 घंटे`)
};

const pt_pt2_past_24_hours = /** @type {(inputs: Past_24_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 horas`)
};

/**
* | output |
* | --- |
* | "24 Hours" |
*
* @param {Past_24_HoursInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const past_24_hours = /** @type {((inputs?: Past_24_HoursInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_24_HoursInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_past_24_hours(inputs)
	if (locale === "de") return de_past_24_hours(inputs)
	if (locale === "it") return it_past_24_hours(inputs)
	if (locale === "ru") return ru_past_24_hours(inputs)
	if (locale === "es") return es_past_24_hours(inputs)
	if (locale === "zh-CN") return zh_cn2_past_24_hours(inputs)
	if (locale === "ja") return ja_past_24_hours(inputs)
	if (locale === "hi") return hi_past_24_hours(inputs)
	if (locale === "pt-PT") return pt_pt2_past_24_hours(inputs)
	return en_past_24_hours(inputs)
});